module.exports = __webpack_public_path__ + "img/1725587577230-WhatsApp Image 2024-09-06 at 09.52.29.jpeg.dc87198d.webp";